import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-bin-clear",
  "use": "foquz-icon-bin-clear-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol viewBox=\"0 0 20 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-bin-clear\"><path d=\"M1.97 5.5H18m-5.03 0V2.75c0-.332-.14-.65-.39-.884a1.38 1.38 0 00-.943-.366H8.304a1.38 1.38 0 00-.943.366c-.25.235-.39.553-.39.884V5.5m-3 0v12.75c0 .597.246 1.17.683 1.591a2.38 2.38 0 001.65.66h7.333c.62 0 1.213-.238 1.65-.66a2.21 2.21 0 00.684-1.59V5.5\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol